export function AddMealToPlanModalFooter({ handleClose, handleAddMeal, disabled }) {
  return (
    <div className="flex items-center justify-end gap-3 border-t border-gray-200 px-6 py-4">
      <button
        onClick={handleClose}
        className="rounded-lg px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
      >
        Cancel
      </button>
      <button
        onClick={handleAddMeal}
        disabled={disabled}
        className="rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-gray-800 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400"
      >
        Update Meal Plan
      </button>
    </div>
  );
}
